import { isInVariation } from '@coolblue-development/next-split-testing/server';
import { mergeDictionaries } from '../Dictionary/mergeDictionaries.js';
import VariationsRepository from '../global/VariationsRepository.js';
export const applyVariations = async (translations, language) => {
    // Prevent mutation of the original translations, since the result is tailored to the current request
    const result = structuredClone(translations);
    const variationsMap = VariationsRepository.getVariationsMap();
    if (!variationsMap[language]) {
        return result;
    }
    const variations = variationsMap[language];
    for (const resource in variations) {
        for (const variationId in variations[resource]) {
            if (!(await isInVariation(variationId)) || !result[resource]) {
                continue;
            }
            result[resource] = mergeDictionaries(result[resource], [variations[resource][variationId]], {
                skipEmpty: true,
            });
        }
    }
    return result;
};
//# sourceMappingURL=applyVariations.js.map